export function IcoTopButton({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1 6.79587L7.00008 1M7.00008 1L13 6.79587M7.00008 1C7.00008 8.34817 7.00008 19 7.00008 19"
        stroke="#1B1B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
